export default function conditionalClass (condition : boolean, trueClass : string | undefined, falseClass : string | undefined) {
    return condition?trueClass : falseClass;
}